module.exports = __webpack_public_path__ + "media/demo.efedaaca.mp4";